import { GetterTree } from "vuex";
import { RootState } from "..";
import { PlatformLogsState } from "./platformLogs.module";

export const PLATFORM_LOGS_GETTERS: GetterTree<PlatformLogsState, RootState> = {
    platformLogs: (state) => state.platformLogs,
    pagination: (state) => state.pagination,
    stats: (state) => state.stats,
    appliedFilters: (state) => state.appliedFilters,
    filters: (state) => state.filters,
    loading: (state) => state.loading,

    hasLogs: (state) => state.platformLogs.length > 0,
    totalItems: (state) => state.pagination.totalItems,
    totalPages: (state) => state.pagination.totalPages,
};
